import * as ApiManager from '../_manager';

export const adminWidget = {
  list: (payload) => {
    return ApiManager.callApi(`/admin/widget/list`, payload);
  },
  get: (payload) => {
    return ApiManager.callApi(`/admin/widget/get`, payload);
  },
  create: (payload) => {
    return ApiManager.callApi(`/admin/widget/create`, payload);
  },
  update: (payload) => {
    return ApiManager.callApi(`/admin/widget/update`, payload);
  },
};
